export const INGREDIENT_FAMILIES = [
    'water',
    'salt',
    'leaven',
    'sugar',
    'fat',
    'dairy',
    'egg',
    'fruit',
    'nutSeed',
    'inclusion',
    'malt',
    'acid',
    'flavouring',
    'liquid',
    'other',
    'unknown',
];
export const INGREDIENT_FORMS = ['fresh', 'dried', 'powder', 'other'];
export const COMPOSITION_KEYS = [
    'waterPct',
    'fatPct',
    'sugarPct',
    'carbohydratePct',
    'proteinPct',
    'fibrePct',
    'saltPct',
];
export const INGREDIENT_PROPERTY_KEYS = ['ph', 'diastaticPower'];
//# sourceMappingURL=types.js.map